export default "__VITE_ASSET__62f38b25__"